import { useMutation, useQueryClient } from "@tanstack/react-query";
import i18n from "i18n";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
import { DATA_LAKE_API_ROUTES, DATA_LAKE_CONFIG_QUERY_KEYS } from "data-lake/Constants";
const updateDataLakeConfig = ({ config }) => fetch("PUT", qualifyUrl(DATA_LAKE_API_ROUTES.DataLakeAPIController.config.base().url), {
  ...config
});
const useDataLakeConfigMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: onUpdateDataLakeConfig } = useMutation({
    mutationFn: updateDataLakeConfig,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_CONFIG_QUERY_KEYS });
      UserNotification.success(
        i18n.t("notifications.config_updated", { ns: "enterprise_data_lake" }),
        i18n.t("notifications.config_update_title", { ns: "enterprise_data_lake" })
      );
    },
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.config_update_failed", { ns: "enterprise_data_lake", error: errorThrown }),
        i18n.t("notifications.config_update_title", { ns: "enterprise_data_lake" })
      );
    }
  });
  return { onUpdateDataLakeConfig };
};
export default useDataLakeConfigMutation;
